import TrainingDashboard from "./TrainingDashboard";

const TrainingDashboardConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/trainingDashboard',
            element: <TrainingDashboard />,
        },
    ],
}

export default TrainingDashboardConfig;